module.exports = __webpack_public_path__ + "img/service.0862d117.png";